/**
 * Global application settings
 */
export const SETTINGS: any = {
    ENABLE_MUSIC: true,
    DEBUG_MOVEMENT_SPEED: 10,
    LOGIN_SCREEN: {
        INTRO_ANIMATION_SPEED: 2 // Was 8
    }
};
